<template>
    <div>
      <div>
        <app-form
          v-bind:parentObject="{
            formid: this.formid,
            sectid: this.id,
            data: this.formData,
            pageTitle: this.pageTitle,
            pageTitleValue: this.pageTitleValue,
            errMsg: this.errMsg,
            isEdit: this.editMode,
          }"
          v-on:input="formData= $event"
          v-on:save="saveHandler"
          v-on:cancel="cancelHandler"
          v-on:error="errorHandler"
        />
  
        <div v-if="isErr">
          <app-error
            v-bind:parentError="{
              data: this.errMsg,
              isErr: this.isErr,
            }"
            v-on:closeError="isErr = $event"
          />
        </div>
  
        <div v-if="isConfirm">
          <app-confirm
            v-bind:parentObject="{
              pageTitleValue: this.pageTitleValue,
              isConfirm: this.isConfirm,
            }"
            v-on:confirm="deleteHandler($event)"
            v-on:cancelConfirm="isConfirm = !isConfirm"
          />
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import FormSetupEditSectionItemForm from "../../../components/performance/formsetup/FormDetails";
  import ErrorDialog from "../../../components/common/ErrorDialog";
  import ConfirmDialog from "../../../components/common/ConfirmDialog";
  
  export default {
    components: {
      "app-form": FormSetupEditSectionItemForm,
      "app-error": ErrorDialog,
      "app-confirm": ConfirmDialog,
    },
  
    data() {
      return {
        id: this.$route.params.id,
        formid: this.$route.params.reviewform.id,
        pageTitle: this.$t('Setupformreviewsectiondetails.editreviewformsection'),
        pageTitleValue: this.$route.params.section.sectname,
        formData: {
          formcode: this.$route.params.reviewform.formcode,
          formname: this.$route.params.reviewform.formname,
          sectname: this.$route.params.section.sectname,
          sectweightage: this.$route.params.section.sectweightage,
          secttype: this.$route.params.section.pmsectiontype,
          stamp: 0,
          userid: this.$store.getters.userId,
        },
  
        errMsg: "",
        isErr: false,
        // loading: true,
        // editMode: true,
        isConfirm: false,
      };
    },
  
    methods: {
  
      errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
      },
  
    //   async loadReviewForm() {
    //     const vm = this;
  
    //     try {
    //       const res = await this.$store.dispatch('get', {url: "/reviewform/" + vm.id});
    //       vm.formData = res.data.rec[0];
    //       vm.pageTitleValue = res.data.rec[0].formcode;
    //     } catch (err) {
    //       vm.isErr = !vm.isErr;
    //       vm.errMsg = err;
    //     }
    //   },
  
      // async loadRankMapDetailsHandler() {
      //   const vm = this;
  
      //   try {
      //     const res = await this.$store.dispatch('get', {url: "/rankmapsetdetails/" + this.id});
      //     vm.rankmapSetDetailsList = res.data.rec.map(item => {
      //           return {
      //             ...item,
      //             isLastText: item.isLast === 1 ? 'Yes' : 'No'
      //           };
      //         });
      //   } catch (err) {
      //     vm.isErr = !vm.isErr;
      //     vm.errMsg = err;
      //   }
      // },
  
  
    //   saveHandler() {
    //     const vm = this;
  
    //     if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
    //       return false;
    //     }
  
    //     this.$store.dispatch('put', {url: "/reviewform/" + vm.id, payload: this.formData})
    //       .then((res) => {
    //         if (res.data.error) {
    //           vm.isErr = !vm.isErr;
    //           vm.errMsg = res.data.error;
    //         } else {
    //           this.$router.push({ name: "formsetuplist" });
    //         }
    //       })
    //       .catch((err) => {
    //         vm.isErr = !vm.isErr;
    //         vm.errMsg = err;
    //       });
    //   },
    },
  
    mounted() {
      // Promise.all([this.loadReviewForm(), this.loadRankMapDetailsHandler()])
    //   Promise.all([this.loadReviewForm()])
    //     .then(() => {
    //       this.loading = false;
    //     })
    //     .catch((err) => {
    //       this.isErr = true;
    //       this.errMsg = err;
    //     });
    },
  };
  </script>